import { Button, Group, Modal, Stack, Text, Title, CopyButton, rem, Input } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
import { downloadQRCode } from '@mygpt/app';
import { showNotification } from '@mantine/notifications';

interface ShareModalProps {
  opened: boolean;
  onClose: () => void;
  url: string;
  id: string;
}

const ShareModal = ({ opened, onClose, url, id }: ShareModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Title order={4}>{t('widget.share_url')}</Title>}
      centered
      size={420}
      radius={16}
    >
      <Stack gap={28} align="center">
        <Group className="w-full" gap={8}>
          <Input
            value={url}
            readOnly
            size="xs"
            styles={{
              input: {
                background: '#f6f6f8',
              },
            }}
            className="flex-1"
          />
          <CopyButton value={url} timeout={2000}>
            {({ copied, copy }) => (
              <Button
                size="xs"
                variant="light"
                color="violet"
                radius="md"
                onClick={() => {
                  copy();
                  showNotification({
                    message: t('link_copied'),
                    color: 'green.5',
                  });
                }}
              >
                {t('copy_link')}
              </Button>
            )}
          </CopyButton>
        </Group>

        <Stack align="center" gap={12} mt={8}>
          <QRCode
            id="share-qrcode"
            value={url}
            size={180}
            bgColor="#fff"
            fgColor="#000"
            style={{ borderRadius: rem(8) }}
          />
          <Button
            size="xs"
            variant="light"
            color="violet"
            radius="sm"
            onClick={() => downloadQRCode({ domId: '#share-qrcode', fileName: `widget-qrcode-${id}` })}
            style={{ width: rem(180) }}
          >
            {t('settings.access_control.download_qrcode')}
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default ShareModal;
